import React, { useState, useEffect, FunctionComponent } from 'react'

import { Flex } from '@theme-ui/components'
import { useLocation, Link } from 'react-router-dom'

import styled from 'styled-components'

import { baseColors, Lock, makeTransition, Text } from '@fairhq/common'

import { Minus } from './assets/icons/Minus'
import { Plus } from './assets/icons/Plus'
import { SubMenuItem } from './SubMenuItem'
import { IReportsSidebarMenuGroup } from './types/reportSidebarMenuGroup'

const MenuLink = styled(Link)<{ $enabled: boolean }>`
  cursor: ${({ $enabled }) => ($enabled ? 'pointer' : 'default')};
  flex-basis: 100%;

  &:hover {
    text-decoration: none;
  }
`

export const MenuGroup: FunctionComponent<IReportsSidebarMenuGroup> = ({
  baseUrl,
  text,
  url,
  items,
  enabled,
  icon,
  onClick,
}) => {
  const location = useLocation()
  const [opened, setOpened] = useState(
    url ? location.pathname.startsWith(baseUrl || url) : false
  )

  const hasChildren = items !== undefined && items.length > 0

  useEffect(() => {
    if (url && location.pathname.startsWith(baseUrl || url) && !opened) {
      setOpened(true)
    }
  }, [location, url, opened, baseUrl])

  const active = url ? location.pathname.startsWith(url) : false
  return (
    <>
      <MenuLink to={enabled ? url : '#'} $enabled={!!enabled}>
        <Flex
          sx={{
            cursor: enabled ? 'pointer' : 'not-allowed',
            alignItems: 'center',
            color: baseColors.contentInverseContent,
            transition: makeTransition('color'),
            bg: active
              ? baseColors.frameActiveState
              : baseColors.frameBackground,
            svg: { flexShrink: 0 },
            textDecoration: 'none',
            ':hover': {
              bg: enabled
                ? baseColors.statesHoverBackground
                : baseColors.statesDisabledBackground,
              color: enabled
                ? baseColors.contentInverseContent
                : baseColors.contentDisabled,
            },
          }}
          onClick={onClick}
        >
          <Flex sx={{ alignItems: 'center', gap: '8px', p: '8px', pr: '0' }}>
            {enabled ? icon : <Lock />}
            <Text element="span" type="body" fontWeight={400} size="xs">
              {text}
            </Text>
          </Flex>
          {hasChildren && enabled && (
            <Flex
              sx={{
                ml: 'auto',
                padding: '8px',
                alignItems: 'center',
                justifyContent: 'center',
                userSelect: 'none',
              }}
              onClick={e => {
                e.preventDefault()
                setOpened(!opened)
              }}
            >
              {hasChildren && (opened ? <Minus /> : <Plus />)}
            </Flex>
          )}
        </Flex>
      </MenuLink>

      {opened && hasChildren && (
        <Flex
          sx={{
            bg: baseColors.frameActiveState,
            flexDirection: 'column',
            flexBasis: '100%',
          }}
        >
          {items &&
            items.map(
              itemProps =>
                itemProps.enabled && (
                  <SubMenuItem key={itemProps.text} {...itemProps} />
                )
            )}
        </Flex>
      )}
    </>
  )
}
